import React, { useState } from 'react';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    /** Kutunun sinifi (giriste 'form-control bg-white', formlarda 'form-control form-control-solid'). */
    className?: string
}

/**
 * Sifre kutusu + goz isareti (12.10.2026, Burak): kullanici girdigi sifreyi gorebilir.
 * Giris, Sifremi Degistir ve Kullanici Tanimlari ekranlarinda ortak kullanilir.
 */
const SifreInput = ({ className, style, ...props }: Props) => {
    const [gorunur, setGorunur] = useState(false);

    return (
        <div className='position-relative'>
            <input
                {...props}
                type={gorunur ? 'text' : 'password'}
                className={className}
                style={{ ...style, paddingRight: 44 }}
            />
            <button
                type='button'
                tabIndex={-1}
                onClick={() => setGorunur(!gorunur)}
                aria-label={gorunur ? 'Şifreyi gizle' : 'Şifreyi göster'}
                title={gorunur ? 'Şifreyi gizle' : 'Şifreyi göster'}
                className='btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-2'
            >
                <i className={'fa ' + (gorunur ? 'fa-eye-slash' : 'fa-eye') + ' text-gray-500 fs-5'} />
            </button>
        </div>
    );
};

export default SifreInput;
